import "./SocketStatus.css"
import { useGlobal } from "../../core/Global"
import FlexRow from "../base/FlexRow"
import Icon from "../base/Icon"
import Indicator from "../base/Indicator"
import { HubConnectionState } from "@microsoft/signalr"


export default function SocketStatus() {

    const [global] = useGlobal()

    return (
        <>
            {
                (global.socketState == HubConnectionState.Connecting || global.socketState == HubConnectionState.Reconnecting) &&
                global.initilized && global.user &&
                <FlexRow className="socket-status-banner bg-warning py-3" justify="center">
                    <Indicator text="Connecting..." />
                </FlexRow>
            }
        </>
    )
}